<div class="menu-component">
  <div class="navbar-inverse side-collapse menu-droite">
    <nav role="navigation" class="navbar-collapse">
      <ul class="nav navbar-nav main-menu">
        @if (logements$ | async; as logements) {
          @if (logements?.length) {
            <li><a routerLink="/accueil" class="picto-home"><span>Accueil</span></a></li>
            <li><a routerLink="/mon-logement" class="picto-logement" data-intro="logement"><span>Mon logement</span></a></li>
            @if (isSonergiaPartner((logementCourant$ | async))) {
              <li><a routerLink="/travaux" class="picto-travaux-renovation" data-intro="parcours-travaux"><span>Parcours travaux</span></a></li>
            }
          }
        }
        <ng-container>
          <ng-container>
            <li>@if (isParcoursTravauxEnabled() && !isSonergiaPartner((logementCourant$ | async))) {
              <a routerLink="/parcours-travaux" class="picto-travaux-renovation" data-intro="travaux"><span>Projet Travaux</span></a>
            }</li>
          </ng-container>
        </ng-container>
        @if (logements$ | async; as logements) {
          @if (logements?.length) {
            @if ((logementCourant$ | async)?.currentUserIsOccupant) {
              <li><a routerLink="/rt2012/suivi-des-consommations" class="picto-rt2012"><span>Consommations</span></a></li>
            }
            <li><a routerLink="/documents" class="picto-dossier-ouvert" data-intro="documents"><span>Documents</span></a></li>
            <li><a routerLink="/mes-equipements" class="picto-baignoire" data-intro="equipements"><span>Mes équipements</span></a></li>
            <li><a routerLink="/actions" class="picto-calendrier" data-intro="actions"><span>Actions</span></a></li>
            <li><a routerLink="/actualites" class="picto-article" data-intro="actualites"><span>Actualités</span></a></li>
            <li><a routerLink
              ="/contacts" class="picto-compte"><span>Contacts</span></a></li>
              <li><a routerLink="/conseils" class="picto-article"><span>Conseils</span></a></li>
              @if (showAnnouncements((logementCourant$ | async))) {
                <li><a routerLink="/annonces" class="picto-partenaire"><span>Annonces partenaire</span></a></li>
              }
            }
          }
          @if (!previsualisation) {
            <li><a routerLink="/mon-compte" class="picto-compte" data-intro="compte"><span>Mon compte</span></a></li>
          }
          <li><a routerLink="/infos-generales" class="picto-aide"><span>Infos générales</span></a></li>
          <li><a (click)="modalService.open(modalNousContacter, {size: 'lg'})" class="picto-enveloppe"><span>Nous contacter</span></a></li>
          @if (!previsualisation) {
            <li><a href="/logout" (click)="logout()" class="picto-croix"><span>Se déconnecter</span></a></li>
          }
        </ul>
      </nav>
    </div>
  </div>

  <ng-template #modalNousContacter>
    <div class="modal-header">
      <h4 class="modal-title">Nous contacter</h4>
      @if ((logementCourant$ | async)?.societe?.partner?.contactClient === true && (logementCourant$ | async)?.correspondantClient) {
        <p class="modal-sub-title">
          Ce formulaire permet de contacter l'équipe CLÉA ou votre correspondant client. L'équipe CLÉA se tient à votre disposition uniquement pour des questions concernant l'application CLÉA.
        </p>
      } @else {
        Ce formulaire permet de contacter l'équipe CLÉA et non le promoteur/ constructeur/ syndic de votre logement. Nous ne pourrons malheureusement pas vous aider pour des questions de réserves/ pannes/ dysfonctionnement de votre logement.
      }
    </div>
    <div class="modal-body">
      <app-nous-contacter></app-nous-contacter>
    </div>
  </ng-template>
